import React, { Fragment, Component } from 'react'
import { COLORS } from '../../../../styles/colors';
import { WORKOUT_LIBRARY_MESSAGE } from '../../../../static-content';
import { NUMBER } from '../../../../constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadMoreIcon from './../../../LoadMoreIcon';
import { isMobile } from 'react-device-detect';
import Post from "../post/Post";
import PostForm from "../share/PostForm";
import "./feed.css";

export class Feed extends Component {

  constructor(props) {
    super(props)
    this.state = {
        dataLoaded: false,
        editItem: null,
        list: [],
        hasMore: false,
        total: 0,
        topic: null,
        topicId: null, 
        title: '',
        isFirstResponseFetched: false,
        isNewPostShow: false
    }
  }

  componentWillUnmount() {
    this.timer = null;
  }
  

  getTranscodeItems(id, type) {
    const ids = [];
    let list = this.state.list;
    for(let i = 0; i < list.length; i++) {
       const l = list[i];
       if (l.isTranscoding) {
        ids.push(l._id)
       }
    }
    if (ids.length > 0) {
      this.props.getTranscodeItems(id, type, ids).then((res) => {
        const data = res.data;
        let list = this.state.list;
        list = list.map((l) => {
          const findIndex = data.findIndex((l) => l._id === l._id);
          let obj;
          if (findIndex > -1) {
            obj = {
              isTranscoding: data[findIndex]['isTranscoding'],
              url: data[findIndex]['url']
            }
          }
          return {
            ...l,
            ...obj
          }
        });
        this.setState({
          list: list
        })
      });
    }
  }
  
  componentDidMount() {
      const user = this.props.user;
      const userType = user.type;
      if  (userType && userType.includes('brand')) {
        const userId = user._id ? user._id : user.id;
        this.props.fetchSectionTopic('channel', userId).then((res) => {
          this.setState({
              topic: res,
              topicId: res._id,
              title: 'Posts',
              isFirstResponseFetched: true
          })
          this.initialLoad(res._id);
        });
      } else {
        const id = this.props.match.params.id;
        if (id) {
          this.props.fetch(id, 'topic').then((res) => {
            this.setState({
                topic: res,
                topicId: res._id,
                title: res.title,
                isFirstResponseFetched: true
            })
            this.initialLoad(res._id);
          });
        } else {
          this.props.fetchSectionTopic('photo', user._id).then((res) => {
            this.setState({
                topic: res,
                topicId: res._id,
                title: 'Photos',
                isFirstResponseFetched: true
            })
            this.initialLoad(res._id);
          });
        }
      }
  }

 
  initialLoad(id) {
    this.timer = setInterval(() => {
      this.getTranscodeItems(id, 'post');
    }, 30000)
    this.fetchIntroItem({
      skip: NUMBER.ZERO,
      limit: NUMBER.ONE,
      topicId: id,
      postType: 'intro'
    });
  }

  fetchIntroItem(req) {
    this.props.fetchListData({
        ...req,
        type: 'post'
    }).then((res) => {
      const updateList = [
        ...this.state.list,
        ...res.data
      ];
      const total = res.metadata.length > 0 ? res.metadata[0].total : 0
      this.setState({
        dataLoaded: true,
        list: updateList,
        hasMore: updateList.length < total,
        total: total
      })
      this.fetchItem({
        skip: NUMBER.ZERO,
        limit: NUMBER.TEN,
        topicId: req.topicId
      })
    });
  }
  
  fetchItem(req) {
    this.props.fetchListData({
        ...req,
        type: 'post'
    }).then((res) => {
      const updateList = [
        ...this.state.list,
        ...res.data
      ];
      const total = res.metadata.length > 0 ? res.metadata[0].total : 0
      this.setState({
        dataLoaded: true,
        list: updateList,
        hasMore: updateList.length < total,
        total: total
      })
    });
  }

  loadMoreItem = () => {
    this.fetchItem({
      skip: this.state.list.length,
      limit: NUMBER.TEN,
      topicId: this.state.topicId
    });
  }

  onDeletePost = (id, action) => {
    if(action === 'delete') {
      const updateList = [...this.state.list]
      const findIndex = updateList.findIndex((l) => l._id === id);
      if (findIndex > -1) {
        updateList.splice(findIndex, 1);
        this.setState({
          list: [...updateList]
        })
      }
    }
  }

  render() { 
    
    let { user, history, isMobile, showLoader, hideLoader } = this.props;
    let { topic, list, hasMore, total, title, isFirstResponseFetched } = this.state;
    console.log('isMobile', isMobile)
   
    return (
      <Fragment>
         <div className={isMobile ? 'mobile-feed' : 'feed'}>
          <div className="feedWrapper">
            <PostForm topicId = {this.state.topicId} {...this.props} />
            {this.state.dataLoaded &&
                <InfiniteScroll
                    dataLength={list.length}
                    next={this.loadMoreItem}
                    hasMore={ hasMore}
                    loader={<LoadMoreIcon></LoadMoreIcon>}
                  >

              {
               list.map((p, index) => (
                <Post onDeletePost={this.onDeletePost} postIndex = {index} topic={topic} itemType='post' {...this.props} key={p._id} item={p} />
               ))
              }
                    
                </InfiniteScroll>
            }
           
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Feed;


// WEBPACK FOOTER //
// ./src/components/social/shared/feed/Feed.jsx